import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  ACTIVE_INACTIVE_VENDOR_USER_REQUEST,
  ADD_VENDOR_USER_REQUEST,
  ASSIGN_VENDOR_USER_REQUEST,
  GET_UNASSIGNED_VENDOR_USER_LIST_REQUEST,
  GET_VENDOR_USER_LIST_REQUEST,
  RESEND_VENDOR_USER_EMAIL_REQUEST,
} from "./type";
import {
  activeInactiveVendorUserSuccess,
  addVendorUserSuccess,
  assignVendorUserSuccess,
  getUnassignedVendorUserListSuccess,
  getVendorUserListRequest,
  getVendorUserListSuccess,
  resendVendorUserEmailSuccess,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";

function* vendorUserList({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorUserList",
      data,
      null,
      "vendor",
    );
    if (res.status) {
      yield put(getVendorUserListSuccess(res.data));
    } else {
      yield put(getVendorUserListSuccess([]));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(getVendorUserListSuccess([]));
    handleApiCallException(error);
  }
}

function* unassignedVendorUserList({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorUnassignedUserList",
      data,
      null,
      "vendor",
    );
    if (res.status) {
      yield put(getUnassignedVendorUserListSuccess(res.data));
    } else {
      yield put(getUnassignedVendorUserListSuccess([]));
      handleApiCallException(res.message);
    }
  } catch (error) {
    yield put(getUnassignedVendorUserListSuccess([]));
    handleApiCallException(error);
  }
}

function* assignVendorUser({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorUserAssign",
      data.values,
      null,
      "vendor",
    );
    if (res.status) {
      ApiResponseMessage(res.message, SUCCESS);
      yield put(assignVendorUserSuccess(res));
      yield put(getVendorUserListRequest(data.dispatchData));
    } else {
      yield put(assignVendorUserSuccess(res));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(assignVendorUserSuccess());
    handleApiCallException(error);
  }
}

function* addVendorUser({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorUser",
      data.values,
      null,
      "vendor",
    );
    if (res.status) {
      ApiResponseMessage(res.message, SUCCESS);
      yield put(addVendorUserSuccess(res));
      yield put(getVendorUserListRequest(data.dispatchData));
    } else {
      yield put(addVendorUserSuccess(res));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(addVendorUserSuccess());
    handleApiCallException(error);
  }
}

function* activeInactiveVendorUser({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorUserStatus",
      {
        vendorId: data.dispatchData?.vendorId,
        vendorUserId: data.vendorUserId,
        isActive: data.isActive,
      },
      null,
      "vendor",
    );
    if (res.status) {
      yield put(activeInactiveVendorUserSuccess(res));
      ApiResponseMessage(res.message, SUCCESS);
      yield put(getVendorUserListRequest(data.dispatchData));
    } else {
      yield put(activeInactiveVendorUserSuccess(res));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(activeInactiveVendorUserSuccess());
    handleApiCallException(error);
  }
}

function* resendVendorUserEmail({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorUserResendEmail",
      {
        vendorId: data.dispatchData?.vendorId,
        vendorUserId: data.vendorUserId,
      },
      null,
      "vendor",
    );
    if (res.status) {
      yield put(resendVendorUserEmailSuccess(res));
      ApiResponseMessage(res.message, SUCCESS);
    } else {
      yield put(resendVendorUserEmailSuccess(res));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(resendVendorUserEmailSuccess());
    handleApiCallException(error);
  }
}

function* watchVendorUserRequest() {
  yield takeLatest(GET_VENDOR_USER_LIST_REQUEST, vendorUserList);
  yield takeLatest(GET_UNASSIGNED_VENDOR_USER_LIST_REQUEST, unassignedVendorUserList);
  yield takeLatest(ASSIGN_VENDOR_USER_REQUEST, assignVendorUser);
  yield takeLatest(ADD_VENDOR_USER_REQUEST, addVendorUser);
  yield takeLatest(ACTIVE_INACTIVE_VENDOR_USER_REQUEST, activeInactiveVendorUser);
  yield takeLatest(RESEND_VENDOR_USER_EMAIL_REQUEST, resendVendorUserEmail);
}

function* AdminVendorUserSaga() {
  yield all([fork(watchVendorUserRequest)]);
}

export default AdminVendorUserSaga;
